// Session-local last-seen tracking for agent chat conversations.
// Stored in localStorage so it survives reloads but is per-browser/per-admin.
// Upgrade to a server-side `last_admin_read_at` column if multi-admin becomes a thing.

const KEY_PREFIX = 'dippy_chat_lastread_';

export function getLastSeen(conversationId: string): number | null {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + conversationId);
    return raw ? parseInt(raw, 10) : null;
  } catch {
    return null;
  }
}

export function markRead(conversationId: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + conversationId, String(Date.now()));
  } catch {
    // localStorage unavailable (private mode, quota); silently ignore
  }
}

export function isUnread(conv: { id: string; last_message_at: string | null }): boolean {
  if (!conv.last_message_at) return false;
  const lastSeen = getLastSeen(conv.id);
  if (lastSeen == null) return true;
  return new Date(conv.last_message_at).getTime() > lastSeen;
}
